<script>
    import { onMount, onDestroy } from 'svelte';

    export let params = {};

    onMount(() => {
        window.scrollTo(0, 0);

        try {
            if (params && params.setState instanceof Function) {
                params.setState({
                    pageTitle: '',
                    pageTitleTag: '',
                });
            }
        } catch (err) {
            console.error(err);
        }
    });

    onDestroy(() => {

    });

    let email;
    let password;
    async function authLogin() {

    }

    let error;

</script>

<div class="canvas__col">
    <section class="auth-block tail">
        <h2 class="auth-block__title tail__title">Вход</h2>
        <p class="auth-block__text tail__text">Введите логин и пароль, которые вы использовали при регистрации на Инсташпионе</p>
        <div class="auth-block__form-wrapper form">
            <input type="email" class="general-input auth-block__input" placeholder="Введите e-mail" bind:value={email} />
            <input type="password" class="general-input auth-block__input" placeholder="Введите пароль" bind:value={password} />
            <button class="button button_shadow auth-block__btn" on:click={authLogin}>войти</button>

            {#if error}
                <p class="auth-block__form-error tail__error">{error}</p>
            {/if}
        </div>
        <p class="auth-block__text tail__text">или войдите с помощью аккаунта:</p>
        <div class="auth-block__social-wrapper">
            <div class="auth-block__social-item">
                <img role="button" title="VKontakte" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_vk.svg" alt="VK" class="auth-block__social-icon" />
            </div>
            <div class="auth-block__social-item">
                <img role="button" title="Google" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_google.svg" alt="Google" class="auth-block__social-icon" />
            </div>
            <div class="auth-block__social-item">
                <img role="button" title="Mail.ru" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_mailru.svg" alt="Mail.ru" class="auth-block__social-icon" />
            </div>
            <div class="auth-block__social-item">
                <img role="button" title="Одноклассники" src="/spy20-lk/icons/auth-page/auth-social/auth-icon_odnoklassniki.svg" alt="OK" class="auth-block__social-icon" />
            </div>
        </div>
    </section>
    <section class="auth-block__additional">
        <a href="/site/password-reset?language=ru-RU&url=https://instashpion.ru/auth/login&backUrl=https://instashpion.ru&redirectUrl=/instashpion/dashboard&theme=spy&service=spy&type=iframe&is_new_login=1" class="button button_textual auth-block__additional-btn">Не могу войти</a>
    </section>

    <section class="auth-register-block">
        <h3 class="auth-register-block__title">Впервые у нас?</h3>
        <a href="https://auth.zengram.ru/site/signup?language=ru-RU&url=https://instashpion.ru/auth/login&backUrl=https://instashpion.ru&redirectUrl=/instashpion/dashboard&theme=spy&service=spy&type=iframe&is_new_login=1" class="button button_ghost auth-register-block__btn">зарегистрируйтесь</a>
    </section>
</div>


<style>

</style>